import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./layouts/admin/index";
import AuthLayout from "layouts/auth";
import MemberLayout from "layouts/member";
import SignUp from "views/auth/SignUp";
import Landing from "views/Landing";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  return (
    <AuthProvider>
      <Routes>
        {/* Landing Page - Default Route */}
        <Route path="/" element={<Landing />} />
        
        {/* Auth Routes */}
        <Route path="auth/*" element={<AuthLayout />} />
        <Route path="register" element={<SignUp />} />

        {/* Admin Protected Routes */}
        <Route
          path="admin/*"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminLayout />
            </ProtectedRoute>
          }
        />

        {/* Member Protected Routes */}
        <Route
          path="member/*"
          element={
            <ProtectedRoute allowedRoles={["user"]}>
              <MemberLayout />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
};

export default App;
